import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";

export default function AdminLoginPage() {
    const { login, user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from || "/admin";
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (user && user.role === "admin") navigate(from, { replace: true });
    }, [user, from, navigate]);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            await login(email, password);
            navigate(from, { replace: true });
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-brand-sand flex items-center justify-center px-6" data-testid="admin-login-page">
            <div className="w-full max-w-md bg-brand-paper border border-brand-line p-10">
                <div className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-4">
                    — Admin
                </div>
                <h1 className="font-serif text-4xl text-brand-ink mb-8">Sign in</h1>
                <form onSubmit={onSubmit} className="space-y-6" data-testid="admin-login-form">
                    <label className="block">
                        <span className="block text-sm text-brand-muted mb-2">Email</span>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            data-testid="admin-login-email"
                            className="w-full bg-transparent border-b border-brand-line py-2 text-brand-ink focus:outline-none focus:border-brand-ink"
                        />
                    </label>
                    <label className="block">
                        <span className="block text-sm text-brand-muted mb-2">Password</span>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            data-testid="admin-login-password"
                            className="w-full bg-transparent border-b border-brand-line py-2 text-brand-ink focus:outline-none focus:border-brand-ink"
                        />
                    </label>
                    {error && (
                        <div className="text-sm text-red-700" data-testid="admin-login-error">
                            {error}
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={submitting}
                        data-testid="admin-login-submit"
                        className="w-full bg-brand-ink text-brand-paper py-3 text-sm tracking-wide hover:bg-black transition-colors disabled:opacity-60"
                    >
                        {submitting ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
        </div>
    );
}
